import { Grid2 as Grid } from '@mui/material'
import { FC } from 'react'
import { StratificationMap } from './StratificationMap'
import { StratificationPanel } from './StratificationPanel/StratificationPanel'
import { StratificationProvider } from './StratificationContext'

export const StratificationHome: FC = () => {
  return (
    <StratificationProvider>
      <Grid container width="100%">
        <Grid size={{ xs: 8, md: 6, lg: 4 }}>
          <StratificationPanel />
        </Grid>
        <Grid size={{ xs: 4, md: 6, lg: 8 }}>
          <StratificationMap />
        </Grid>
      </Grid>
    </StratificationProvider>
  )
}
